// extracted by mini-css-extract-plugin
export var copyableField = "_q0-4";
export var customerBadge = "_q0-0";
export var customerInfoTitle = "_q0-2";
export var details = "_q0-1";
export var dropdownContainer = "_q0-5";
export var dropdownImage = "_q0-6";
export var editAssigneeForm = "_q0-a";
export var editButton = "_q0-3";
export var email = "_q0-7";
export var hidden = "_q0-d";
export var input = "_q0-8";
export var saveButton = "_q0-b";
export var shopifyIcon = "_q0-c";
export var suggestionBadge = "_q0-e";
export var suggestionText = "_q0-f";
export var username = "_q0-9";